import React, { useState } from 'react';
import { Collapse } from 'reactstrap';

import './styles.scss';
import IconArrowDown from '../../assets/arrow.svg';
import PrimaryButton from '../PrimaryButton';
import { useTranslation } from 'react-i18next';
import ConfirmationModal from '../Modal';

const CollapsedBox = ({
  title,
  buttonTitle,
  onConfirmRequest,
  listTitle,
  listItemsText,
  modalTitle,
  modalDescription,
  disabledRequestButton,
  displayErrorMessageData,
}) => {
  const [isExpanded, setExpanded] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const { t } = useTranslation();

  return (
    <div className="styled-wrapper">
      <button className="styled-box-header" onClick={() => setExpanded(!isExpanded)}>
        <p className="styled-title">{title}</p>
        <img src={IconArrowDown} alt="arrow-icon" className={`styled-arrow-icon${isExpanded ? ' expanded' : ''}`} />
      </button>
      <Collapse className={`styled-collapse${displayErrorMessageData ? ' error' : ''}`} isOpen={isExpanded}>
        <div className="styled-box-wrapper">
          {displayErrorMessageData ? (
            <>
              <p className="styled-small-text">{displayErrorMessageData.errorDescription}</p>
              <p className="styled-small-text">TRACKING ID: {displayErrorMessageData.trackingId}</p>
            </>
          ) : (
            <>
              <div className="styled-list-wrapper">
                <p className="styled-list-title">{listTitle}</p>
                <ul>
                  <li className="styled-list-item">{listItemsText.first}</li>
                  <li className="styled-list-item">{listItemsText.second}</li>
                  <li className="styled-list-item">{listItemsText.third}</li>
                </ul>
              </div>
              <PrimaryButton onClick={() => setOpenModal(true)} disabled={disabledRequestButton}>
                {buttonTitle}
              </PrimaryButton>
              <ConfirmationModal
                isOpen={openModal}
                title={modalTitle}
                placeholder={t('companyInfo.modalPlaceholder')}
                description={modalDescription}
                onClose={() => setOpenModal(false)}
                onConfirm={() => {
                  onConfirmRequest();
                  setOpenModal(false);
                }}
                confirmButtonTitle={t('companyInfo.confirmationButton')}
              />
            </>
          )}
        </div>
      </Collapse>
    </div>
  );
};

export default CollapsedBox;
